import React from "react";
import ProductsListingPage from "~/src/components/product/pages/ProductsListingPage";

export default function ProductsPage() {
  return <ProductsListingPage />;
}
